// utils/firstReg.js
import moment from 'moment';

// Use full names (current behavior). For short names, use moment formatting instead.
const monthNames = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

export function getFirstReg(firstReg) {
  if (!firstReg || typeof firstReg !== 'string') return undefined;
  const components = firstReg.split('-');
  if (components.length !== 2) return undefined;

  const [year, monthStr] = components;
  const monthIndex = parseInt(monthStr, 10) - 1;
  if (Number.isNaN(monthIndex) || monthIndex < 0 || monthIndex > 11) return undefined;

  return `${monthNames[monthIndex]} ${year}`;
}

export function getAge(firstReg) {
  if (!firstReg || typeof firstReg !== 'string') return undefined;
  const components = firstReg.split('-');
  if (components.length !== 2) return undefined;

  const [year, monthStr] = components;
  const dateString = `${year}/${monthStr}/01`;
  const starts = moment(dateString);
  const ends = moment();

  // Requires moment-precise-range plugin for preciseDiff
  if (!starts.isValid() || !ends.isValid() || !moment.preciseDiff) return undefined;

  const diff = moment.preciseDiff(starts, ends, true);
  return `${diff.years} years, ${diff.months} months`;
}
